import React, { useContext } from 'react';
import { CheckCircle } from 'lucide-react';

import { calculatePercentage, formatDateShort } from '../../../services/calculations';
import { SubscriptionStatus } from '../../../domain/suscriptions/model';
import { roleContext } from '../../../context/role/context';
import './style.css';

function SubscriptionInfoCard({ subscription }) {
    const { profile } = useContext(roleContext);

    if (!subscription) {
        return null;
    }

    const { electronic_documents, ai_tokens, plan, status } = subscription;
    const roleId = profile?.colaborador ? profile.colaborador.role_id : profile?.role_id;
    const isAccountant = roleId === 4;

    const renderConsumption = () => {
        if (!electronic_documents) return null;

        const { limit, usage, is_unlimited, period_end } = electronic_documents;
        const percentage = calculatePercentage(usage, limit, is_unlimited);
        const renewalDate = formatDateShort(period_end);

        return (
            <div className="subscription-consumption">
                <div className="consumption-header">
                    <span className="consumption-label">Documentos Electrónicos</span>
                    <span className="consumption-stats">
                        <span className="usage-text">{usage}</span> / {is_unlimited ? '∞' : limit}
                    </span>
                </div>
                {!is_unlimited && (
                    <div className="progress-container">
                        <div
                            className="progress-bar"
                            style={{ width: `${percentage}%` }}
                        ></div>
                    </div>
                )}
                <div className="card-footer">
                    {renewalDate && <span className="renewal-date">Renueva el {renewalDate}</span>}
                </div>
            </div>
        );
    };

    const renderAiTokens = () => {
        if (!isAccountant || !ai_tokens) return null;

        const { limit, usage, is_unlimited } = ai_tokens;
        const percentage = calculatePercentage(usage, limit, is_unlimited);

        return (
            <div className="subscription-consumption" style={{ marginTop: '1.5rem' }}>
                <div className="consumption-header">
                    <span className="consumption-label">Tokens de IA (Contador)</span>
                    <span className="consumption-stats">
                        <span className="usage-text">{usage}</span> / {is_unlimited ? '∞' : limit}
                    </span>
                </div>
                {!is_unlimited && (
                    <div className="progress-container">
                        <div
                            className="progress-bar"
                            style={{ width: `${percentage}%`, backgroundColor: '#a855f7' }}
                        ></div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="subscription-info-card">
            <div className="info-header">
                <div className="header-title-group">
                    <CheckCircle className="check-icon" size={20} />
                    <h3>Detalles de Suscripción</h3>
                </div>
                <span className={`status-badge ${status}`}>{status.toUpperCase()}</span>
            </div>

            <div className="info-grid">
                <div className="info-item">
                    <label>PLAN ACTUAL</label>
                    <p>{plan?.name || 'N/A'}</p>
                </div>
                <div className="info-item align-right">
                    <label>ID SUSCRIPCIÓN</label>
                    <p>#{subscription.id}</p>
                </div>
            </div>

            {renderConsumption()}
            {renderAiTokens()}
        </div>
    );
}

export default SubscriptionInfoCard;
